// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3U0Yv","subheader":"ReorderModal_subheader__31Cra","listWrap":"ReorderModal_listWrap__2UOgJ"};